import { render, staticRenderFns } from "./EntityTemplate.vue?vue&type=template&id=74c61467&scoped=true&"
import script from "./EntityTemplate.vue?vue&type=script&lang=js&"
export * from "./EntityTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EntityTemplate.vue?vue&type=style&index=0&id=74c61467&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c61467",
  null
  
)

export default component.exports